import { render, staticRenderFns } from "./DiscardProposedChangesDialog.vue?vue&type=template&id=2b56060d&scoped=true"
import script from "./DiscardProposedChangesDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DiscardProposedChangesDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DiscardProposedChangesDialog.vue?vue&type=style&index=0&id=2b56060d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b56060d",
  null
  
)

export default component.exports